module.exports = __webpack_public_path__ + "img/arrow-down-circle.b2066acf.svg";